import { Product } from './';
import { Site } from './Site';
import { ResourceType } from './ResourceType';

export interface Consumption {
    id?: number;
    quantity: number;
    volume?: number;
    satisfied: number;
    satisfiedVolume?: number;
    product: Product;
    plannedIncomingQuantity?: number;
    plannedIncomingVolume?: number;
    agreementDescription?: string;
    maxDelay?: number;
    hasMaxDelay: boolean;
    preferredTime?: string;
    time: string;
    packAlias?: string;
    description?: string;
    stateAlias?: string;
    reviewDeadline?: string;
    active: boolean;
    productType?: ResourceType;
    receiptTime?: string;
    packId?: number;
    internalTime?: string;
    internalQuantity?: number;
    internalQuantityVolume?: number;
    important?: boolean;
    sourceSitesId?: number[];
    sourceSites?: string;
    subSiteName?: string;
    preferredSubSiteName?: string;
    unloadingSiteName?: string;
    warehouseName?: string;
    preferredWarehouseName?: string;
    // calced
    agreementStatusName?: string;
    deviationDuration?: string;
    consignmentId?: number;
    consignment?: string;
    usageResourceTypeIds?: number[];
    usageResourceTypes?: ResourceType[];
}

export enum ConsumptionsType {
    DELIVERY_PROPOSALS = 'delivery-proposals',
    POSTPONED = 'postponed',
    UNSATISFIED = 'unsatisfied',
    SUPPLIERED = 'suppliered',
    STOCK = 'stock',
    COMPENSATION = 'compensation',
    PRELIMINARY = 'preliminary'
}

export interface ConsumptionsSubPacks {
    id?: number;
    productId?: string;
    quantity: number;
    start: string;
    end: string;
    profit?: number;
    event?: string;
    placement: Site;
    state?: string;
    externaldata?: string;
    ownerId?: number;
    projectId?: number;
    objectId?: number;
    objectCode?: string;
    sourcePackValue?: number;
    product: Product;
    volume?: number;
    packId?: number;
}

export interface ConsumptionEditData {
    packId?: number;
    internalTime?: string;
    internalQuantity?: number;
    usedResourceTypes?: number[];
}
